export default {
  path: '/teacher',
  redirect: '/teacher/dashboard',
  component: () => import('../layouts/main/Main.vue'),
  children: [
    {
      path: 'dashboard',
      name: 'dashboard',
      component: () => import('../views/pages/teacher/Home.vue'),
      meta: { title: 'Dashboard', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/students/view',
      name: 'teacher-students-view',
      component: () => import('../views/pages/teacher/students/View.vue'),
      meta: { title: 'Students', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/students/edit/:student_id',
      name: 'teacher-students-edit',
      component: () => import('../views/pages/teacher/students/Edit.vue'),
      meta: { title: 'Edit student', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/students/add',
      name: 'teacher-students-add',
      component: () => import('../views/pages/teacher/students/Add.vue'),
      meta: { title: 'Add student', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/vje/activity',
      name: 'teacher-vje-activity',
      component: () => import('../views/pages/teacher/vje/StudentExperiencesSummary.vue'),
      meta: { title: 'Student experience summary', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/vje/settings',
      name: 'teacher-vje-settings',
      component: () => import('../views/pages/teacher/vje/Settings.vue'),
      meta: { title: 'Virtual Job Experience settings', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/vje/activity/student/:id',
      name: 'teacher-vje-activity-student',
      component: () => import('../views/pages/teacher/vje/StudentExperiences.vue'),
      meta: { title: 'Student experiences', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/vje/prework/:id/workplace-safety',
      name: 'teacher-vje-ws-student',
      component: () =>
        import('../views/WorkExperiences/components/Prework/Teacher/WorkplaceSafety.vue'),
      meta: { title: 'Student workplace safety', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/vje/prework/:id/workplace-preparation',
      name: 'teacher-vje-wp-student',
      component: () =>
        import('../views/WorkExperiences/components/Prework/Teacher/WorkplacePreparation.vue'),
      meta: { title: 'Student workplace preparation', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/vje/prework/:id/application',
      name: 'teacher-vje-wp-student-app',
      component: () =>
        import('../views/WorkExperiences/components/Prework/Teacher/Application.vue'),
      meta: { title: 'Student application', requiresAuth: 'teacher' },
    },
    {
      path: '/teacher/vje/experience/view/:id',
      name: 'teacher-vje-activity-experience',
      component: () => import('../views/pages/teacher/vje/StudentExperience.vue'),
      redirect: '/teacher/vje/experience/view/:id/activities',
      meta: { title: 'Student experience', requiresAuth: 'teacher' },
      children: [
        {
          path: 'activities',
          name: 'teacher-we-activities',
          component: () => import('../views/WorkExperiences/components/Activities.vue'),
          meta: { title: 'Activities', requiresAuth: 'teacher' },
        },
        {
          path: 'activities/:slug',
          name: 'activity-teacher',
          component: () => import('../views/WorkExperiences/components/Activity.vue'),
          meta: { title: 'Activity', requiresAuth: 'teacher' },
        },
        {
          path: 'projects',
          name: 'teacher-we-projects',
          component: () => import('../views/WorkExperiences/components/Projects.vue'),
          meta: { title: 'Projects', requiresAuth: 'teacher' },
        },
        {
          path: 'reflection',
          name: 'teacher-we-reflection',
          component: () =>
            import('../views/WorkExperiences/components/Postwork/ReflectionReadOnly.vue'),
          meta: { title: 'Reflection', requiresAuth: 'teacher' },
        },
        {
          path: 'thankyou-letter',
          name: 'teacher-we-thankyouletter',
          component: () =>
            import('../views/WorkExperiences/components/Postwork/ThankyouLetterReadOnly.vue'),
          meta: { title: 'Thank you Letter', requiresAuth: 'teacher' },
        },
        {
          path: 'certificate',
          name: 'teacher-we-certificate',
          component: () =>
            import('../views/WorkExperiences/components/Postwork/CertificateTeacher.vue'),
          meta: { title: 'Certificate', requiresAuth: 'teacher' },
        },
        {
          path: 'experience-info',
          name: 'teacher-we-experienceinfo',
          component: () =>
            import('../views/WorkExperiences/components/WorkExperience/ExperienceInfo.vue'),
          meta: { title: 'Experience Information', requiresAuth: 'teacher' },
        },
      ],
    },
    {
      path: 'help',
      name: 'teacherhelp',
      component: () => import('../views/pages/teacher/Help.vue'),
      meta: { title: 'Help', requiresAuth: 'teacher' },
    },
    {
      path: 'notifications',
      name: 'teacher-notifications',
      component: () => import('../views/pages/Notifications.vue'),
      meta: { title: 'Notifications', requiresAuth: 'teacher' },
    },
    {
      path: 'make-suggestion',
      name: 'teacher-make-suggestion',
      component: () => import('../views/pages/teacher/MakeSuggestion.vue'),
      meta: { title: 'Make a suggestion', requiresAuth: 'teacher' },
    },
    {
      path: 'logout',
      name: 'teacherlogout',
      component: () => import('../views/pages/teacher/Logout.vue'),
      meta: { title: 'Log Out', requiresAuth: 'teacher' },
    },
  ],
};
